<sd-slider
  [brand]="brand"
  [customConfig]="recipeCardsSliderConfig"
  [size]="size"
  [items]="recipeCards"
  [itemTemplate]="recipeCardTemplate"
  [context]="context"
  (slideNext)="onSlideChange($event)"
  (slidePrev)="onSlideChange($event)"
/>

<ng-template #recipeCardTemplate let-item>
  <article>
    <sd-recipe-card
      [brand]="brand ? brand : item?.card?.brand"
      [isLoading]="isLoading"
      [recipeContent]="item?.card"
      [titleLevel]="item?.titleLevel"
      [maxStar]="item?.maxStar ? item?.maxStar : 5"
      (recipeClicked)="onClick(item?.card)"
      [twicPicsAutoSize]="twicPicsAutoSize"
    />
  </article>
</ng-template>
